import { AppDispatch } from 'app/store';
import { AttributeType } from 'data/types';
import { setProjectSettingValue } from 'features/project';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const sweetalert = withReactContent(Swal);

const JOIST_WIDTH_CODE = 'joist_width';

export type JoistWidthValue = '16"' | '24"';

export async function promptJoistWidthForStandardCassette(): Promise<JoistWidthValue | null> {
  const result = await sweetalert.fire({
    title: 'Confirm joist spacing',
    html: '<span>The standard ceiling cassette is designed for 24-inch joist spacing and will not fit between 16-inch joists. Are the joists in your home spaced 24 inches on center?</span>',
    icon: 'question',
    showCancelButton: true,
    showCloseButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    confirmButtonText: 'Yes, 24-inch joists',
    cancelButtonText: 'No, 16-inch joists',
    buttonsStyling: false,
    customClass: {
      confirmButton:
        'inline-flex items-center justify-center rounded-md px-3 text-sm font-medium leading-4 shadow-sm border focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 border-transparent bg-blue-600 text-white hover:bg-blue-700 py-3 m-2',
      cancelButton:
        'inline-flex items-center justify-center rounded-md px-3 text-sm font-medium leading-4 shadow-sm border focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 border-gray-300 bg-white text-gray-700 hover:bg-gray-50 py-3 m-2'
    }
  });
  if (result.isConfirmed) return '24"';
  if (result.dismiss === Swal.DismissReason.cancel) return '16"';
  return null;
}

export async function maybePromptAndApplyJoistWidth(
  dispatch: AppDispatch,
  projectSettings: AttributeType[]
): Promise<boolean> {
  const existing = projectSettings.find(
    (s) => s.code === JOIST_WIDTH_CODE
  )?.value;
  if (existing === '24"') return true;
  if (existing === '16"') return false;
  const answer = await promptJoistWidthForStandardCassette();
  if (!answer) return true;
  dispatch(setProjectSettingValue(JOIST_WIDTH_CODE, answer));
  return answer === '24"';
}
